import {
    LayoutDashboard,
    Cable,
    Receipt,
    SlidersHorizontal,
    Activity,
    ScrollText,
    Database,
    ListChecks,
    Map,
    Users, Gauge, Energy, EvCharger, Building, Shield, Cpu, Settings, Zap, DollarSign,
} from "@/components/icons";
import React from "react";

export interface NavItem {
    to: string;
    label: string;
    Icon: React.ElementType;
    adminOnly?: boolean;
    orgUserAllowed?: boolean;
    tierRequired?: "prime";
    // External targets (e.g. the legacy /console UI served by Flask) bypass
    // React Router and use a regular <a href> so the browser does a full
    // navigation out of the SPA.
    external?: boolean;
}

export const nav: NavItem[] = [
    { to: "/", label: "Dashboard", Icon: Gauge },
    { to: "/devices", label: "Devices", Icon: EvCharger },
    { to: "/sessions", label: "Sessions", Icon: Energy },
    { to: "/billing", label: "Billing", Icon: Receipt, adminOnly: true },
    // Load balancing: an org manager configures circuit groups within their own
    // org(s); a system admin manages all. Hidden from drivers. (Backend scopes each
    // group/unit to the manager's organization.)
    { to: "/load-balancing", label: "Load Balancing", Icon: SlidersHorizontal, adminOnly: true, orgUserAllowed: true },
    { to: "/admin/dashboard", label: "AdminPanel", Icon: LayoutDashboard, adminOnly: true },
    { to: "/metrics", label: "Metrics", Icon: Activity, adminOnly: true },
    { to: "/system-health", label: "System Health", Icon: ListChecks, adminOnly: true },
    { to: "/mobile-versions", label: "Mobile Versions", Icon: Activity, adminOnly: true },
    { to: "/cache-stats", label: "Cache Stats", Icon: Database, adminOnly: true },
    { to: "/logs", label: "Logs", Icon: ScrollText, adminOnly: true },
    { to: "/ecache", label: "ECache", Icon: Database, adminOnly: true },
    { to: "/eventlog", label: "Event Log", Icon: Cable, adminOnly: true },
    { to: "/audit", label: "Audit Log", Icon: ScrollText, adminOnly: true },
    { to: "/map", label: "Map", Icon: Map, adminOnly: true },
    { to: "/users", label: "Users", Icon: Users, adminOnly: true },
    { to: "/organizations", label: "Organizations", Icon: Building, adminOnly: true, orgUserAllowed: true },
    { to: "/access-control", label: "Access Control", Icon: Shield, adminOnly: true, orgUserAllowed: true },
    { to: "/pricing-profiles", label: "Pricing Profiles", Icon: DollarSign, adminOnly: true, orgUserAllowed: true },
    { to: "/emulator", label: "Emulator", Icon: Cpu, adminOnly: true },
    { to: "/pando", label: "Pando", Icon: Zap, adminOnly: true },
    { to: "/console/", label: "Console", Icon: Settings, adminOnly: true, external: true },
];

export interface NavVisibilityCtx {
    isAdmin: boolean;    // system administrator
    isManager: boolean;  // manager of ≥1 organization
    isFree: boolean;
}

/**
 * Whether a nav item is visible to the current user. Org-scoped items
 * (orgUserAllowed) are organization-MANAGEMENT pages: a system admin or an
 * organization manager sees them; a restricted driver never does.
 */
export function isNavItemVisible(item: NavItem, { isAdmin, isManager, isFree }: NavVisibilityCtx): boolean {
    if (item.adminOnly && !isAdmin && !(item.orgUserAllowed && isManager)) {
        return false;
    }
    return !(item.tierRequired === "prime" && isFree);
}